import * as React from 'react';
import Loading from './Loading';
import Failure from './Failure';
import Cost from '../logic/domain/cost/Cost';

interface Props {
  isLoading: boolean;
  cost: Cost;
}

const pathView = (props: Props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  if (props.cost) {
    return (
      <a href={props.cost.url} target="_blank" rel="noopener">
        {props.cost.title}
      </a>
    );
  }
  return <Failure errorMessage="Failure" />;
};

export default pathView;



// WEBPACK FOOTER //
// ./src/components/PathView.tsx